export function formatKeybindingHint(input?: string) {
  return input?.replaceAll('+', 'Plus')?.replaceAll('-', '+')
}
